import { twMerge } from "tailwind-merge";

export const renderHeadline = (headline: string) =>
{
    const parts = headline.split(/(\*.*?\*)/gu);

    return parts.map((part, index) =>
    {
        if (part.startsWith("*") && part.endsWith("*"))
        {
            const text = part.slice(1, -1);

            return (
                <span
                    key={index}
                    className={Wind.style({
                        fontWeight: "font-bold",
                        textTransform: "uppercase",
                    }).class}
                >
                    {text}
                </span>
            );
        }

        return (
            <span key={index}>
                {part}
            </span>
        );
    });
};

export function HeadlineDisplay({
    headline,
    bannerText = "Daily Headline",
    className,
    inverted = false,
    whiteBanner,
}: {
    headline: string;
    bannerText?: string;
    className?: string;
    inverted?: boolean;
    whiteBanner?: boolean;
})
{
    return (
        <div
            className={twMerge(Wind.style({
                backgroundColor: inverted ? "bg-dark-blue" : "bg-parchment",
                padding: "p-4",
                marginX: "mx-4",
                position: "relative",
                marginTop: "mt-8",
            }).class, className)}
        >
            <h2
                className={Wind.style({
                    position: "absolute",
                    top: "top-0",
                    left: "left-1/2",
                    transformTranslateY: "-translate-y-1/2",
                    transformTranslateX: "-translate-x-1/2",
                    display: "inline-flex",
                    alignItems: "items-center",
                    justifyContent: "justify-center",
                    backgroundColor: whiteBanner ? "bg-white" : inverted ? "bg-poppy-yellow" : "bg-black",
                    whitespace: "whitespace-nowrap",
                    color: inverted ? "text-dark-blue" : "text-parchment",
                    paddingY: "py-2",
                    paddingX: "px-6",
                    borderBottomRightRadius: "rounded-br-full",
                    fontWeight: "font-bold",
                    fontSize: "text-xl",
                    lineHeight: "leading-6",
                    zIndex: "z-[2]",
                }).class}
            >
                {bannerText}
                <div
                    className={Wind.style({
                        backgroundColor: "bg-sharp-red",
                        borderRadius: "rounded-full",
                        width: "w-3",
                        aspectRatio: "aspect-square",
                        position: "absolute",
                        right: "right-8",
                        top: "top-0",
                        transformTranslateY: "-translate-y-1/2",
                        pointerEvents: "pointer-events-none",
                    }).class}
                />
                <div
                    className={Wind.style({
                        backgroundColor: "bg-sharp-red",
                        borderRadius: "rounded-full",
                        width: "w-2",
                        aspectRatio: "aspect-square",
                        position: "absolute",
                        right: "right-5",
                        top: "top-0",
                        transformTranslateY: "-translate-y-full",
                        pointerEvents: "pointer-events-none",
                    }).class}
                />
            </h2>
            <div
                className={Wind.style({
                    backgroundColor: inverted ? "bg-[#1A3657]" : "bg-poppy-yellow",
                    borderBottomRightRadius: "rounded-br-full",
                    position: "absolute",
                    top: "top-10",
                    left: "left-8",
                    width: "w-1/2",
                    aspectRatio: "aspect-[197/39]",
                }).class}
            />
            <div
                className={Wind.style({
                    display: "flex",
                    alignItems: "items-start",
                    justifyContent: "justify-start",
                    flexDirection: "flex-row",
                    color: inverted ? "text-white" : "text-dark-blue",
                    position: "relative",
                }).class}
            >
                <div
                    className={Wind.style({
                        fontSize: "text-6xl",
                        fontFamily: "font-serif",
                        fontWeight: "font-bold",
                        paddingRight: "pr-1",
                    }).class}
                >
                    {headline.substring(0, 1).toUpperCase()}
                </div>
                <div
                    className={Wind.style({
                        fontSize: "text-xl",
                        lineHeight: "leading-[130%]",
                        fontFamily: "font-poppins",
                        paddingTop: "pt-2",
                        textWrap: "text-balance",
                    }).class}
                >
                    {renderHeadline(headline.substring(1))}
                </div>
            </div>
        </div>
    );
}
